// extracted by css-extract-rspack-plugin
export default {"optionsList":"hpFyw"};